import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './Header';

const Dashboard = () => {

  useEffect(() => {
    const fetchData = async () => {
      try {

      } catch (error) {

      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Header label={<p className=''>Your HR World in One Place!</p>} />
      <main id="main" className="main">
        <div className='row mb-5'>
          <div className='col-lg-12'>
            {/* <img className='fluid-image' src='assets/images/homepage-banner.jpg' /> */}
            <div className='homepage-banner rounded'>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='card'>
              <div className='card-body'>
                <div className='content-block mt-2'>
                  <div className='h-4 card-content-headers mb-2'>
                    Welcome to Workwise Portal, your central hub for all things related to Human Resources.
                  </div>

                  <div className='card-description mb-5'>
                    <p>
                      Here, you'll discover a consolidated resource for HR information, links, and systems. Our Employee Central portal streamlines access to HR systems, offering a convenient "one-stop" solution. If you need to access a specific link, simply click on the corresponding name below.
                    </p>
                  </div>
                  <img className='fluid-image-70 rounded' src='assets/images/homepage-image-1.png' />

                </div>
              </div>
            </div>
          </div>
        </div>


        <div className='row'>
          <div className='col-lg-12'>
            <div className='card'>
              <div className='card-header bg-primary text-light h-6 fw-bolder'>
                Latest News / Communication
              </div>
              <div className='card-body'>
                <div className='content-block mt-2'>
                  <div className='d-flex'>
                    <div className='h-4 card-content-headers mb-2'>
                      Deadline: Performance Management.
                    </div>
                    <div className='ms-auto'>
                      12 Sep 24
                    </div>
                  </div>

                  <div className=''>
                    <p>
                      You are reminded that the current Performance Management cycle will close on 29th September 2024. All outstanding assessments are to be completed before or on this date. For any support, please contact your HR Business Partner in this regard.
                    </p>
                  </div>
                </div>
                <br />
                <hr />
                <br />

                <div className='content-block mt-2'>
                  <div className='h-4 card-content-headers mb-2'>
                  </div>
                  <div className='d-flex'>
                    <div className='h-4 card-content-headers mb-2'>
                      Progress Status: Performance Management.
                    </div>
                    <div className='ms-auto'>
                      24 Aug '24
                    </div>
                  </div>
                  <div className=''>
                    <p>
                      A reminder that the current Performance cycle is closing in one month - a snapshot of progress for your area below.
                    </p>
                  </div>
                  <div className='row d-flex'>
                    <div className='col-lg-7 mx-auto mt-4'>
                      <img className='fluid-image-70 rounded ' src='assets/images/homepage-charts.png' />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </main>

    </>
  )
}
export default Dashboard;
